import {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import OverviewDesc from './OverviewDesc'
import OverviewKeyChar1 from './OverviewKeyChar1'
import OverviewKeyChar2 from './OverviewKeyChar2'

import getRounded from '../../../helpers/getRounded'
import {usePersona} from '../../../../store/hooks/persona'
import PersonaOverview from '../../../../api/queries/persona/PersonaOverviewQuery'

const demonsocioInitial = [
  {title: 'Hispanic or Latino', value: 100},
  {title: 'White', value: 100},
  {title: 'Asian', value: 100},
  {title: 'Black or African American', value: 100},
  {title: 'Multiple Races or Other', value: 100},
  {title: 'American Indian and Alaska Native', value: 100},
  {title: 'Native Hawaiian and Other Pacific Islander', value: 100}
]

const Overview = ({filteredPersonaDesc, handlePersonaCustomLabel}) => {
  const [overviewData, setOverviewData] = useState({
    adultCount: 0,
    averageAge: 0,
    population: 0,
    demographics: demonsocioInitial.slice(0, 5),
    gender: []
  })
  const [zeroCountPopulation, setZeroCountPopulation] = useState(false)

  const {personaOverview, loadingPersonaOverview, refetchPersonaOverview, errorLoadingPersonaOverview} =
    PersonaOverview()

  const {personas} = usePersona()

  useEffect(() => {
    if (!loadingPersonaOverview) {
      const data = personaOverview?.personaOverview

      if (data !== undefined && data !== null) {
        const tempDemographics = structuredClone(demonsocioInitial)

        for (const demo of tempDemographics) {
          demo.value = 0
        }
        for (const demo of data.demographics || []) {
          const idx = tempDemographics.findIndex((ele) => ele.title.includes(demo.name))
          tempDemographics[idx] = {title: demo.name, value: demo.percentage}
        }

        const tempGender = []

        tempGender?.push({
          title: `${data.gender?.name}`,
          percentage: `${data.gender?.percentage}%`
        })

        const adultCountInitial = getRounded(data.adultCount)

        const sortedDemographics = [...tempDemographics]
        sortedDemographics.sort((a, b) => b.value - a.value)

        setOverviewData({
          adultCount: adultCountInitial,
          averageAge: data.averageAge,
          population: data.population === 0 ? '< 1' : data.population,
          demographics: sortedDemographics.slice(0, 5),
          gender: tempGender
        })
        setZeroCountPopulation(false)
      } else {
        setOverviewData({
          adultCount: 0,
          averageAge: 0,
          population: 0,
          demographics: [
            {title: '--', value: 0},
            {title: '--', value: 0},
            {title: '--', value: 0},
            {title: '--', value: 0},
            {title: '--', value: 0}
          ],
          gender: [{title: '--', percentage: 0}]
        })
        setZeroCountPopulation(true)
      }
    }
  }, [personaOverview, loadingPersonaOverview, errorLoadingPersonaOverview])

  // refetch logic here
  useEffect(() => {
    refetchPersonaOverview()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personas])

  return (
    <>
      <OverviewDesc filteredPersonaDesc={filteredPersonaDesc} handlePersonaCustomLabel={handlePersonaCustomLabel} />
      <OverviewKeyChar1
        loadingPersonaOverview={loadingPersonaOverview}
        adultCount={overviewData.adultCount}
        population={overviewData.population}
        isZeroCountPopulation={zeroCountPopulation}
        handlePersonaCustomLabel={handlePersonaCustomLabel}
      />
      <OverviewKeyChar2
        averageAge={overviewData.averageAge}
        gender={overviewData.gender}
        demographics={overviewData.demographics}
        isZeroCountPopulation={zeroCountPopulation}
        handlePersonaCustomLabel={handlePersonaCustomLabel}
      />
    </>
  )
}
Overview.propTypes = {
  filteredPersonaDesc: PropTypes.array.isRequired,
  handlePersonaCustomLabel: PropTypes.func.isRequired
}

export default Overview

/*
Component Understanding: Overview
- The Overview component is responsible for displaying a summary of persona data, including demographics, gender, population, and other key characteristics, by fetching and processing data from various providers.

Function Comments:
  -useEffect (1st instance): Processes and updates persona overview data when the data fetch is complete.
  -useEffect (2nd instance): Triggers a refetch of persona overview data when dependencies like personas or filters change.
*/
